import { render, staticRenderFns } from "./TransferHelp.vue?vue&type=template&id=4d3489a9&scoped=true&"
import script from "./TransferHelp.vue?vue&type=script&lang=js&"
export * from "./TransferHelp.vue?vue&type=script&lang=js&"
import style0 from "./TransferHelp.vue?vue&type=style&index=0&id=4d3489a9&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d3489a9",
  null
  
)

export default component.exports